module.exports = __webpack_public_path__ + "assets/img/38e75d07e4b437cd859d23e55c99d102.svg";